export const QUERY_KEYS = {
  BANKRUPTCY_DETAILS: 'bankruptcy-details',
}